import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" {...props}><path d="M22.5 36.15h3v-6h6v-3h-6v-6h-3v6h-6v3h6zM7 44q-1.2 0-2.1-.9Q4 42.2 4 41V15q0-1.2.9-2.1.9-.9 2.1-.9h9V7q0-1.2.9-2.1.9-.9 2.1-.9h10q1.2 0 2.1.9.9.9.9 2.1v5h9q1.2 0 2.1.9.9.9.9 2.1v26q0 1.2-.9 2.1-.9.9-2.1.9zm0-3h34V15H7v26zm12-29h10V7H19zM7 41V15v26z" /></svg>);